import React from "react";
import { Link } from "react-router-dom";
import "../../assets/styles/p2p_organization_setup.scss";

export default function P2PAccessDeniedPage({ pageName, requiredRole }) {
  return (
    <div className="container py-5 p2p-page">
      <div className="p2p-card" style={{ maxWidth: 560, margin: "0 auto" }}>
        <h2 className="p2p-page-title">Access denied</h2>
        <p className="p2p-page-subtitle">
          You do not have permission to open this page.
        </p>
        {pageName ? (
          <p>
            <strong>Page:</strong> {pageName}
          </p>
        ) : null}
        {requiredRole ? (
          <p>
            <strong>Required access:</strong> {requiredRole}
          </p>
        ) : null}
        <p className="p2p-helper">
          Contact your Company Admin or platform administrator if you believe you
          should have access.
        </p>
        <Link to="/home" className="btn btn-primary mt-3">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
